export default __webpack_public_path__ + "static/media/Logo-Posher-Prize.0a49e59e.png";